import { render } from "./FormSelectPage.vue?vue&type=template&id=ed87ae48&ts=true"
import script from "./FormSelectPage.vue?vue&type=script&lang=ts"
export * from "./FormSelectPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__